import { createAsyncThunk } from '@reduxjs/toolkit';

import { GetTriageringsoppsettRequest, GetTriageringsoppsettResponse } from '../../types/Helsenorge.Dialog.InternalEntitiesEntities';

import { get as getProxy } from '@helsenorge/framework-utils/hn-proxy-service';
import { TextMessage } from '@helsenorge/framework-utils/types/entities';

import { getTriageringsoppsettError, getTriageringsoppsettLoading, getTriageringsoppsettResponse } from './selectors';
import { PartialState } from './state';
import { RootState } from '../';
import { formatErrorMessage } from '../../utils/format-error';

type TriageringsoppsettParams = Record<keyof GetTriageringsoppsettRequest, number>;

function shouldFetchTriageringsoppsett(state: PartialState): boolean {
  return !getTriageringsoppsettLoading(state) && !getTriageringsoppsettResponse(state) && !getTriageringsoppsettError(state);
}

export const fetchTriageringsoppsett = createAsyncThunk<
  GetTriageringsoppsettResponse,
  TriageringsoppsettParams,
  { state: RootState; rejectValue: TextMessage }
>(
  'triageringsoppsett/get',
  async (params, { rejectWithValue }) => {
    try {
      return (await getProxy('dialog', 'api/v1/Triageringsoppsett', params)) as GetTriageringsoppsettResponse;
    } catch (error) {
      const message = error instanceof Error ? error.message : '';
      return rejectWithValue(formatErrorMessage(message));
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState();
      return shouldFetchTriageringsoppsett(state);
    },
  }
);
